import type { FaireProductEntity } from "../../entity_types/product";

export const p_w6chhwjp72: FaireProductEntity = {
  token: "p_w6chhwjp72",
  type: "product",
  name: "Sardine Dangle - Italian Summer Aesthetic",
  brandToken: "b_h93v6v8mbm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e386174da9c58e0b268e74668ef54201f46a61e31083b3479158548cd9a1a28d.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.02,
  description:
    "The Sardine Dangle from Aurora Boheme embodies the Italian summer aesthetic with its unique design. These earrings are more than just an accessory, they are a statement of self-expression. They encapsulate the bohemian spirit that Aurora Boheme is renowned for. Feel beautiful and self-confident with every wear.",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:46.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
